import { render, staticRenderFns } from "./KlarnaExpress.vue?vue&type=template&id=06278f79&scoped=true&"
import script from "./KlarnaExpress.vue?vue&type=script&lang=js&"
export * from "./KlarnaExpress.vue?vue&type=script&lang=js&"
import style0 from "./KlarnaExpress.vue?vue&type=style&index=0&id=06278f79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06278f79",
  null
  
)

export default component.exports